export default class AssetLoadServiceEvent {
    constructor(type, data) {
        this.type = type;
        this.data = data;
    }
}

AssetLoadServiceEvent.LOAD_COMPLETE_WITH_ERRORS = "AssetLoadServiceEvent.LOAD_COMPLETE_WITH_ERRORS";
AssetLoadServiceEvent.RETRY_LOADING_FAILED_ITEMS = "AssetLoadServiceEvent.RETRY_LOADING_FAILED_ITEMS";

AssetLoadServiceEvent.LOAD_FILE_COMPLETE = "AssetLoadServiceEvent.LOAD_FILE_COMPLETE";
AssetLoadServiceEvent.LOAD_COMPLETE = "AssetLoadServiceEvent.LOAD_COMPLETE";
AssetLoadServiceEvent.LOAD_PROGRESS = "AssetLoadServiceEvent.LOAD_PROGRESS";
AssetLoadServiceEvent.LOAD_FILE_ERROR = "AssetLoadServiceEvent.LOAD_FILE_ERROR";